import { useQuery } from "react-query";
import { axiosClient } from "../services/axiosInstance";

const useGetPhysicalActivities = () => {
  const data = useQuery(["getPhysicalActivities"], () =>
    axiosClient.post(`Setting/GepSettingList?groupSettingId=20`)
  );
  return data;
};
export default useGetPhysicalActivities;
